import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import { TABLE_HEADERS, keyMapping } from '../../../../../constants/PartCategoryLists';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const PartCategory = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  // useEffect(() => {
  //   fetchPartCategoryData();
  // }, []);

  const fetchPartCategoryData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/partcategory/list',
        {
          orderBy: 'part_category_id desc',
          page,
          pageSize,
          searchText:searchTerm
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));
      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);
      console.log('response', response);
      setTableData(formattedData);

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
     // toastSuccess("Product Data fetched successfully!");
    } catch (error) {
      console.error('Error fetching part category list:', error);
    }
    finally{
      setLoading(false)
    }
  };


  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITPARTCATEGORY}`, { state: { data: rowData } });
    console.log("rowdata", rowData)
  }
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPartCategoryData(newPage);
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchPartCategoryData();
    }
  }, [searchTerm]);
  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Part Category</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Part Category</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"   >{totalActive} </h5>
            <h6>Active Part Category</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Inactive Part Category</h6>
          </div>
          <button
            className='addcustomerbutton'
            onClick={() => navigate(ROUTES_NAVIGATION.ADDPARTCATEGORY)}
          >
            Add Part Category
          </button>
        </div>
      </div>

      <div className='tableWrapper'>
        <div className='admin-list-container'>
        <div className='listsearchContainer'>
          <h5>Part Category List</h5>
            <div>
              <SearchInput
                placeholder="Search Part Category"
                onSearch={fetchPartCategoryData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </div>
        <CustomTable
          data={tableData}
          headers={TABLE_HEADERS}
          keyMapping={keyMapping}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          itemsPerPage={10}
          onEdit={handleEditButton}
          totalRecords={totalRecords} 
        />
      </div>
    </div>
    )}
    </div>
  );
};

export default PartCategory;
